        // Wait for DOM to be ready
        document.addEventListener('DOMContentLoaded', function() {
            // Check if required elements exist
            const canvas = document.getElementById('sequenceCanvas');
            const contentColumn = document.getElementById('contentColumn');
            
            // Exit early if animation elements don't exist on this page
            if (!canvas || !contentColumn) {
                console.log('Scroll animation elements not found on this page');
                return;
            }
            
            // Register ScrollTrigger plugin
            gsap.registerPlugin(ScrollTrigger);

        // Performance optimizations
        let rafId = null;
        let isRendering = false;
        let lastProgress = -1;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Canvas setup - canvas already declared above
        const ctx = canvas.getContext('2d', { alpha: false }); // Performance optimization
        const video = document.createElement('video');
        let isVideoLoaded = false;
        let videoDuration = 10; // Default fallback duration
        let currentTime = 0;
        let videoLoadAttempts = 0;
        const maxVideoLoadAttempts = 2;
        let videoLoadingComplete = false;
        let initialRenderDone = false; // Track if we've done initial render

        // Animation parameters
        const animationData = {
            progress: 0
        };

        // Video URL
        const videoURL = 'https://cdn.shopify.com/videos/c/o/v/a4111016ecc14babb24a0c6212f43f7a.mp4';

        // JSON data structure for hotspots and content
        const segmentData = {
            "start": {
                "title": "A new way to sweat",
                "subtitle": "This isn’t your grandpa’s sauna setup. Our sauna tents are made to go, but never compromise on a serious sweat.",
                "progress": 0,
                "hotspots": []
            },
            "p1": {
                "title": "Your anywhere hot spot",
                "subtitle": "Saunder sets up in minutes and packs down small enough to fit in your trunk, so you can bring it on any adventure.",
                "progress": 0.33,
                "hotspots": [
                    { 
                        "x": 0.3, 
                        "y": 0.55,
                        "title": "Anchor Points / Tie-Downs",
                        "description": "Ground stakes and ties anchor your sauna experience."
                    },
                    { 
                        "x": 0.5, 
                        "y": 0.45,
                        "title": "Lightweight Materials",
                        "description": "Strong, lightweight fibreglass frame keeps things sturdy without weighing you down."
                    }
                ]
            },
            "p2": {
                "title": "Made better",
                "subtitle": "Our unique three-layer fabric traps the heat and blocks out the elements.",
                "progress": 0.48,
                "hotspots": [
                    { "x": 0.35, "y": 0.4, "title": "Sweatloft™ Fabric", "description": "Insulated 120gsm cotton fill keeps it crazy hot inside while durable, heat-resistant 450D Oxford fabric stays weather-ready." },
                    { "x": 0.7, "y": 0.55, "title": "Cool-Touch Zipper Pulls and Storm Flaps", "description": "Custom silicone pulls stay cool to the touch while storm flaps keep rain and wind out." }
                ]
            },
            "p3": {
                "title": "Built for company",
                "subtitle": "Bring a friend…or three. Our tent is spacious enough for a crew, but you can always stretch out solo.",
                "progress": 0.64,
                "hotspots": [
                    { "x": 0.6, "y": 0.5, "title": "Layout", "description": "High ceilings and a smart layout make entering safe and sweating comfortable." },
                    { "x": 0.5, "y": 0.25, "title": "Height", "description": "Over 205 cm tall—plenty of room to stand, stretch, and relax." }
                ]
            },
            "p4": {
                "title": "Enjoy your view",
                "subtitle": "Sometimes you want to take in your surroundings. Our large insulated windows let you connect to nature or close it all off.",
                "progress": 0.76,
                "hotspots": [
                    { "x": 0.6, "y": 0.4, "title": "Windows", "description": "Clear-view panels bring in light and frame the landscape around you." },
                    { "x": 0.3, "y": 0.4, "title": "Insulated Covers", "description": "Removable velcro covers offer instant privacy and added heat retention." }
                ]
            },
            "end": {
                "title": "Ready, set, sauna",
                "subtitle": "No bookings. No strangers. Just a sweet, sweet sweat on your terms.",
                "progress": 1.0,
                "hotspots": []
            }
        };

        // Generate content blocks from JSON data
        function generateContentBlocks() {
            const contentColumn = document.getElementById('contentColumn');
            
            Object.entries(segmentData).forEach(([key, segment], index) => {
                const contentBlock = document.createElement('div');
                contentBlock.className = `content-block segment-${index}`;
                
                let hotspotHTML = '';
                if (segment.hotspots && segment.hotspots.length > 0) {
                    hotspotHTML = `
                        <ol>
                            ${segment.hotspots.map(hotspot => `
                                <li>
                                    <strong>${hotspot.title}</strong><br>
                                    ${hotspot.description}
                                </li>
                            `).join('')}
                        </ol>
                    `;
                }
                
                contentBlock.innerHTML = `
                    <h1>${segment.title}</h1>
                    <h2>${segment.subtitle}</h2>
                    ${hotspotHTML}
                `;
                
                contentColumn.appendChild(contentBlock);
            });
        }

        // Initialize content blocks
        generateContentBlocks();

        // Info panel elements
        const currentFrameEl = document.getElementById('currentFrame');
        const totalFramesEl = document.getElementById('totalFrames');
        const progressEl = document.getElementById('progress');
        const scrollPosEl = document.getElementById('scrollPos');
        const progressBar = document.querySelector('.progress-bar');

        // Immediately render initial frame to avoid black canvas
        function renderInitialFrame() {
            // Set canvas background to match the container
            ctx.fillStyle = 'rgb(253, 253, 253)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            
            // If video is ready, draw first frame
            if (isVideoLoaded && video.readyState >= 2) {
                const videoAspect = video.videoWidth / video.videoHeight;
                const canvasAspect = canvas.width / canvas.height;
                
                let drawWidth, drawHeight, drawX, drawY;
                
                if (videoAspect > canvasAspect) {
                    drawWidth = canvas.width;
                    drawHeight = canvas.width / videoAspect;
                    drawX = 0;
                    drawY = (canvas.height - drawHeight) / 2;
                } else {
                    drawWidth = canvas.height * videoAspect;
                    drawHeight = canvas.height;
                    drawX = (canvas.width - drawWidth) / 2;
                    drawY = 0;
                }
                
                ctx.drawImage(video, drawX, drawY, drawWidth, drawHeight);
                addHotspots(0);
            } else {
                // Draw fallback at progress 0
                generateFallbackFrame(0);
            }
            
            initialRenderDone = true;
        }

        // Load and setup video with improved error handling
        function loadVideo() {
            if (videoLoadingComplete) {
                console.log('Video loading already completed, skipping');
                return;
            }
            
            videoLoadAttempts++;
            console.log(`Loading video... (Attempt ${videoLoadAttempts}/${maxVideoLoadAttempts})`);
            
            if (videoLoadAttempts > maxVideoLoadAttempts) {
                console.log('Max video load attempts reached, permanently switching to fallback graphics');
                videoLoadingComplete = true;
                isVideoLoaded = false;
                totalFramesEl.textContent = '300';
                progressEl.textContent = 'Fallback Mode';
                renderInitialFrame();
                return;
            }
            
            // Clear any existing event listeners to prevent duplicates
            video.onloadedmetadata = null;
            video.onerror = null;
            video.onprogress = null;
            video.onloadstart = null;
            video.oncanplay = null;
            
            video.muted = true;
            video.preload = 'auto'; // Changed to auto for faster loading
            video.playsInline = true;
            
            // Try without crossOrigin first, then with
            if (videoLoadAttempts === 1) {
                video.removeAttribute('crossOrigin');
            } else {
                video.crossOrigin = 'anonymous';
            }
            
            // Success handler
            video.onloadedmetadata = function() {
                console.log(`✓ Video metadata loaded! Duration: ${video.duration}s`);
                videoDuration = video.duration;
                totalFramesEl.textContent = Math.round(videoDuration * 30);
                
                // Seek to first frame
                video.currentTime = 0;
            };
            
            // When video can actually play (has enough data)
            video.oncanplay = function() {
                if (!videoLoadingComplete) {
                    console.log('✓ Video can play - rendering first frame');
                    videoLoadingComplete = true;
                    isVideoLoaded = true;
                    progressEl.textContent = '0';
                    
                    // Render the first frame immediately
                    renderInitialFrame();
                }
            };
            
            // Handle seeking completion
            video.onseeked = function() {
                if (!initialRenderDone && isVideoLoaded) {
                    renderInitialFrame();
                }
            };
            
            // Error handler with timeout protection
            let errorHandled = false;
            video.onerror = function(e) {
                if (errorHandled) return;
                errorHandled = true;
                
                console.error(`✗ Video load attempt ${videoLoadAttempts} failed:`, {
                    error: video.error?.code,
                    message: video.error?.message,
                    src: video.src
                });
                
                if (videoLoadAttempts < maxVideoLoadAttempts) {
                    console.log(`Retrying in 1 second...`);
                    setTimeout(() => {
                        if (!videoLoadingComplete) {
                            loadVideo();
                        }
                    }, 1000);
                } else {
                    console.log('All video load attempts failed, switching to fallback graphics permanently');
                    videoLoadingComplete = true;
                    isVideoLoaded = false;
                    totalFramesEl.textContent = '300';
                    progressEl.textContent = 'Fallback Mode';
                    renderInitialFrame();
                }
            };
            
            // Progress handler
            video.onprogress = function() {
                if (!isVideoLoaded && video.buffered.length > 0 && videoDuration > 0) {
                    const loadedPercent = (video.buffered.end(0) / videoDuration) * 100;
                    progressEl.textContent = `Loading: ${Math.round(loadedPercent)}%`;
                }
            };
            
            // Timeout fallback - if nothing happens in 10 seconds, give up
            const loadTimeout = setTimeout(() => {
                if (!videoLoadingComplete && !errorHandled) {
                    console.log('Video loading timeout, switching to fallback');
                    video.onerror(new Error('Timeout'));
                }
            }, 10000);
            
            // Clear timeout if video loads successfully
            video.oncanplay = (function(originalHandler) {
                return function() {
                    clearTimeout(loadTimeout);
                    if (originalHandler) originalHandler.call(this);
                };
            })(video.oncanplay);
            
            // Start loading
            video.src = videoURL;
            video.load();
        }

        // Track frame state
        let lastDrawnFrame = -1;
        let videoFrameReady = false;
        let pendingVideoSeek = false;

        // Video seeking with better error handling
        function seekToTime(targetTime) {
            return new Promise((resolve) => {
                if (!isVideoLoaded) {
                    resolve();
                    return;
                }
                
                if (Math.abs(video.currentTime - targetTime) < 0.033) {
                    resolve();
                    return;
                }
                
                pendingVideoSeek = true;
                
                const onSeeked = () => {
                    pendingVideoSeek = false;
                    videoFrameReady = true;
                    video.removeEventListener('seeked', onSeeked);
                    resolve();
                };
                
                video.addEventListener('seeked', onSeeked);
                video.currentTime = targetTime;
                
                // Timeout in case seeking fails
                setTimeout(() => {
                    if (pendingVideoSeek) {
                        video.removeEventListener('seeked', onSeeked);
                        pendingVideoSeek = false;
                        resolve();
                    }
                }, 1000);
            });
        }

        // Render video frame
        async function renderVideoFrame(progress) {
            if (!isVideoLoaded) {
                generateFallbackFrame(progress);
                return;
            }
            
            const targetTime = progress * videoDuration;
            const frameNumber = Math.round(progress * videoDuration * 30);
            
            if (frameNumber === lastDrawnFrame && videoFrameReady && !pendingVideoSeek) {
                return;
            }
            
            await seekToTime(targetTime);
            
            if (video.readyState >= 2 && video.videoWidth > 0 && video.videoHeight > 0) {
                // Clear canvas
                ctx.fillStyle = 'rgb(253, 253, 253)';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                
                // Calculate aspect ratio scaling
                const videoAspect = video.videoWidth / video.videoHeight;
                const canvasAspect = canvas.width / canvas.height;
                
                let drawWidth, drawHeight, drawX, drawY;
                
                if (videoAspect > canvasAspect) {
                    drawWidth = canvas.width;
                    drawHeight = canvas.width / videoAspect;
                    drawX = 0;
                    drawY = (canvas.height - drawHeight) / 2;
                } else {
                    drawWidth = canvas.height * videoAspect;
                    drawHeight = canvas.height;
                    drawX = (canvas.width - drawWidth) / 2;
                    drawY = 0;
                }
                
                // Draw video frame
                ctx.drawImage(video, drawX, drawY, drawWidth, drawHeight);
                addHotspots(progress);
                
                lastDrawnFrame = frameNumber;
                currentTime = targetTime;
                videoFrameReady = true;
            } else {
                generateFallbackFrame(progress);
            }
        }

        // Fallback function with simple rotating square
        function generateFallbackFrame(progress) {
            // Clear canvas with slightly darker background to see feathering
            ctx.fillStyle = 'rgb(240, 240, 240)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Draw rotating square in center
            const centerX = canvas.width / 2;
            const centerY = canvas.height / 2;
            const size = 100;
            
            ctx.save();
            ctx.translate(centerX, centerY);
            ctx.rotate(progress * Math.PI * 4); // 2 full rotations
            
            ctx.fillStyle = '#000';
            ctx.fillRect(-size/2, -size/2, size, size);
            
            ctx.restore();

            // Add hotspots on top of the animation
            addHotspots(progress);
        }

        // Add hotspots function
        function addHotspots(progress) {
            const tolerance = 0.02;
            
            // Find the active segment based on progress
            let activeSegment = null;
            Object.values(segmentData).forEach(segment => {
                if (Math.abs(progress - segment.progress) < tolerance) {
                    activeSegment = segment;
                }
            });
            
            // Draw hotspots if there's an active segment
            if (activeSegment && activeSegment.hotspots) {
                activeSegment.hotspots.forEach((hotspot, index) => {
                    // Convert relative positions to absolute canvas positions
                    const x = hotspot.x * canvas.width;
                    const y = hotspot.y * canvas.height;
                    
                    // Outer circle (subtle glow) - 125% larger than current
                    ctx.beginPath();
                    ctx.arc(x, y, 38, 0, Math.PI * 2);
                    ctx.fillStyle = 'rgba(255, 255, 255, 0.2)';
                    ctx.fill();
                    
                    // Main white circle - 125% larger than current
                    ctx.beginPath();
                    ctx.arc(x, y, 25, 0, Math.PI * 2);
                    ctx.fillStyle = 'white';
                    ctx.fill();
                    
                    // Inner circle (slight transparency for depth) - 125% larger than current
                    ctx.beginPath();
                    ctx.arc(x, y, 19, 0, Math.PI * 2);
                    ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
                    ctx.fill();
                    
                    // Add number in center - 125% larger font than current
                    ctx.fillStyle = '#C83C1F';
                    ctx.font = 'bold 23px Arial';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText((index + 1).toString(), x, y);
                });
            }
        }

        // Optimized render function
        function render() {
            if (isRendering) return;
            
            isRendering = true;
            rafId = requestAnimationFrame(async () => {
                const progress = animationData.progress;
                
                // Skip tiny changes for better performance
                if (Math.abs(progress - lastProgress) < 0.001) {
                    isRendering = false;
                    return;
                }
                lastProgress = progress;
                
                if (isVideoLoaded) {
                    await renderVideoFrame(progress);
                } else {
                    generateFallbackFrame(progress);
                }
                
                // Update info panel
                const totalFrames = isVideoLoaded ? Math.round(videoDuration * 30) : 300;
                const currentFrameNumber = Math.round(progress * totalFrames);
                currentFrameEl.textContent = currentFrameNumber;
                const progressPercent = Math.round(progress * 100);
                progressEl.textContent = progressPercent;
                
                isRendering = false;
            });
        }

        // Function to update active content segment based on animation progress
        function updateActiveSegment(progress) {
            const segments = document.querySelectorAll('.content-block');
            segments.forEach(segment => segment.classList.remove('active'));
            
            // Find the closest segment based on progress
            let closestSegmentIndex = 0;
            let smallestDistance = Infinity;
            
            Object.entries(segmentData).forEach(([key, segment], index) => {
                const distance = Math.abs(progress - segment.progress);
                if (distance < smallestDistance) {
                    smallestDistance = distance;
                    closestSegmentIndex = index;
                }
            });
            
            // Activate the closest segment
            if (segments[closestSegmentIndex]) {
                segments[closestSegmentIndex].classList.add('active');
            }
        }

        // Cleanup function
        function cleanup() {
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
            if (video && isVideoLoaded) {
                video.pause();
                video.src = '';
                video.load();
            }
        }

        // GSAP MatchMedia setup for responsive behavior
        let mm = gsap.matchMedia();

        // Mobile setup (0-767px)
        mm.add("(max-width: 767px)", () => {
            console.log("Mobile setup activated");
            
            // Mobile-specific optimizations
            ScrollTrigger.config({
                autoRefreshEvents: "visibilitychange,DOMContentLoaded,load,resize", // Optimized refresh events
                ignoreMobileResize: false // Allow mobile resize handling
            });
            
            setupScrollTriggers();
            
            return () => {
                // Cleanup function for mobile
                console.log("Mobile cleanup");
                ScrollTrigger.getAll().forEach(trigger => trigger.kill());
            };
        });

        // Desktop setup (768px+)
        mm.add("(min-width: 768px)", () => {
            console.log("Desktop setup activated");
            
            // Desktop-specific optimizations
            ScrollTrigger.config({
                autoRefreshEvents: "visibilitychange,DOMContentLoaded,load,resize"
            });
            
            setupScrollTriggers();
            
            return () => {
                // Cleanup function for desktop
                console.log("Desktop cleanup");
                ScrollTrigger.getAll().forEach(trigger => trigger.kill());
            };
        });

        // ScrollTrigger setup with mobile optimization
        function setupScrollTriggers() {
            // Clear any existing ScrollTriggers
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
            
            // Mobile-optimized ScrollTrigger configuration
            const isMobile = window.innerWidth < 768;
            
            // GSAP Timeline for the canvas animation with pinning
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: ".main-section",
                    start: "top top",
                    end: isMobile ? "+=1600vh" : "+=3200vh",
                    scrub: reducedMotion ? false : (isMobile ? 0.5 : 1),
                    pin: true,
                    anticipatePin: 1,
                    invalidateOnRefresh: true,
                    refreshPriority: -1,
                    snap: reducedMotion ? false : {
                        snapTo: Object.values(segmentData).map(segment => segment.progress),
                        duration: isMobile ? 0.6 : 1.0,
                        delay: isMobile ? 0.2 : 0.4
                    },
                    onUpdate: (self) => {
                        scrollPosEl.textContent = Math.round(self.progress * 100);
                        gsap.set(progressBar, { scaleX: self.progress });
                        updateActiveSegment(self.progress);
                        
                        // Update aria-valuenow for progress bar
                        progressBar.setAttribute('aria-valuenow', Math.round(self.progress * 100));
                    },
                    onRefresh: () => {
                        render();
                    }
                }
            });

            // Animate the progress
            tl.to(animationData, {
                progress: 1,
                duration: 1,
                ease: "none",
                onUpdate: render
            });

            // Content blocks are now controlled by updateActiveSegment() function
            // which is called from the main scroll trigger's onUpdate callback
            // No separate ScrollTriggers needed for content blocks
        }

        // Handle window resize with debouncing
        function resizeCanvas() {
            const container = canvas.parentElement;
            const containerWidth = container.clientWidth;
            const containerHeight = container.clientHeight;
            
            // Use the smaller dimension to maintain square aspect ratio
            let newSize = Math.min(containerWidth, containerHeight);
            
            canvas.style.width = newSize + 'px';
            canvas.style.height = newSize + 'px';
            
            // Re-render current frame
            render();
        }

        // Mobile-specific touch and performance optimizations
        if ('ontouchstart' in window) {
            // Optimize for touch devices
            document.addEventListener('touchstart', function() {}, { passive: true });
            document.addEventListener('touchmove', function() {}, { passive: true });
            
            // Reduce motion on mobile if user prefers
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                gsap.globalTimeline.timeScale(0.5);
            }
        }

        // Handle orientation change on mobile
        window.addEventListener('orientationchange', () => {
            setTimeout(() => {
                ScrollTrigger.refresh();
                resizeCanvas();
            }, 100);
        });

        // Improved resize handler with debouncing
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                ScrollTrigger.refresh();
                resizeCanvas();
            }, 250);
        });

        // Initialize
        totalFramesEl.textContent = '300'; // Default fallback
        lastProgress = 0; // Initialize lastProgress
        
        // Immediately fill canvas with background color to avoid black rectangle
        ctx.fillStyle = 'rgb(253, 253, 253)';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        document.querySelector('.segment-0').classList.add('active');

        // Start video loading attempt
        loadVideo();

        // Initialize everything
        window.addEventListener('load', () => {
            resizeCanvas();
            // Try to render initial frame again in case video is ready now
            if (!initialRenderDone && (isVideoLoaded || videoLoadingComplete)) {
                renderInitialFrame();
            }
        });
        
        }); // End of DOMContentLoaded